export default function PlusIcon({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg
        width={`1em`}
        height={`1em`}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 4.5V13.5M13.5 9L4.5 9"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
}
